export function Logo(props: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_32_25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M61.4238 37.5606L146.095 183.593L243.8 51.4065C259.413 30.2836 244.333 0.385769 218.067 0.385769H39.8694L39.8694 0.385783H61.4238V37.5606Z"
          fill="url(#paint0_linear_32_25)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M195.013 218.451L110.343 72.4209L12.6385 204.608C-2.97428 225.731 12.1055 255.629 38.3721 255.629H195.013V218.451Z"
          fill="url(#paint1_linear_32_25)"
        />
        <path
          d="M18.6336 18.6336C42.9277 -5.66042 82.3161 -5.66041 106.61 18.6337L237.401 149.424C261.695 173.718 261.695 213.107 237.401 237.401V237.401C213.107 261.695 173.718 261.695 149.424 237.401L18.6336 106.61C-5.66047 82.3161 -5.66045 42.9277 18.6336 18.6336V18.6336Z"
          fill="url(#paint2_linear_32_25)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_32_25"
          x1="229.726"
          y1="17.1257"
          x2="169.846"
          y2="90.4245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E56CF" />
          <stop offset="0.485" stopColor="#7049D0" />
          <stop offset="1" stopColor="#39187C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_32_25"
          x1="26.6854"
          y1="235.376"
          x2="79.5828"
          y2="181.355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E56CF" />
          <stop offset="0.485" stopColor="#704BD0" />
          <stop offset="1" stopColor="#39187C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_32_25"
          x1="235.361"
          y1="235.969"
          x2="19.4382"
          y2="22.4992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5218C7" />
          <stop offset="0.375" stopColor="#703FD0" />
          <stop offset="0.75" stopColor="#6E56CF" />
          <stop offset="0.985" stopColor="#836FD6" />
        </linearGradient>
        <clipPath id="clip0_32_25">
          <rect width="256" height="256" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
